export default __webpack_public_path__ + "static/media/logo.639e3cf9.png";